import { render } from "./OrderWechatPay.vue?vue&type=template&id=185afbdc&scoped=true"
import script from "./OrderWechatPay.vue?vue&type=script&lang=js"
export * from "./OrderWechatPay.vue?vue&type=script&lang=js"

import "./OrderWechatPay.vue?vue&type=style&index=0&id=185afbdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185afbdc"]])

export default __exports__